class DriveSubscription {
	id = '';
	name = '';
	type = '';
	plan = null;
	createdAt = null;
	updatedAt = null;
	isPrepaid = false;
	isTrial = false;
	isPromo = false;
	isBasic = false;
	prepaidCouponId = null;
	cancelAtPeriodEnd = false;
	transitionAtEnd = false;
	expiry = null;
	trialExpiry = null;
	renews = false;
	expires = false;
	prepaidDisplayCode = null;
	noExpiry = false;
	oneTimeOffer = false;
	isFreePromo = false;
}

export default DriveSubscription;



// WEBPACK FOOTER //
// ./src/store/models/drive-subscription.js